import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const icon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick?.(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

export default function MapaSelectorPunto({
  lat,
  lng,
  onChange,
  height = 280,
  className = "",
}) {
  const hasPos = lat != null && lng != null && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng));
  const center = hasPos ? [Number(lat), Number(lng)] : [40.4168, -3.7038];

  return (
    <div className={`overflow-hidden rounded-xl border border-zinc-200 ${className}`}>
      <MapContainer
        center={center}
        zoom={hasPos ? 15 : 6}
        style={{ height, width: "100%", zIndex: 0 }}
        key={`${center[0]}-${center[1]}`}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClickHandler onPick={(la, ln) => onChange?.(la, ln)} />
        {hasPos && <Marker position={[Number(lat), Number(lng)]} icon={icon} />}
      </MapContainer>
      <p className="bg-zinc-50 px-3 py-1.5 text-[11px] text-zinc-500">
        Pulsa en el mapa para ajustar la ubicación exacta. También puedes abrirla en Google Maps.
      </p>
    </div>
  );
}
